module.exports = __webpack_public_path__ + "img/JD.d5682eb4.png";